export const REVIEW_ROUTE = {
  path: 'review',
  name: 'Review',
};
